import { render, staticRenderFns } from "./SocialCard.vue?vue&type=template&id=322e9278&"
import script from "./SocialCard.vue?vue&type=script&lang=ts&"
export * from "./SocialCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports